var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-modal__company"},[_c('h3',[_vm._v(_vm._s(_vm.$t('card_modal.ui.account')))]),_c('p',[_vm._v(_vm._s(_vm.account.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }